var map = {
	"./DexProject.png": 4936,
	"./TBA.jpg": 6515,
	"./friendlyrobot.jpg": 7119,
	"./ghgInternship.jpg": 7482,
	"./glow18.jpg": 5318,
	"./glow19.jpg": 5427,
	"./glow20.jpg": 3443,
	"./hex18.jpg": 8332,
	"./junction19.jpg": 1040,
	"./kea19.png": 7103,
	"./mechhive.jpg": 4279,
	"./openInnovationMinor.jpg": 9284,
	"./paaspop19.jpg": 3824,
	"./paaspop20.jpg": 5092,
	"./philips.jpg": 6179,
	"./philipsInternship.jpg": 5905,
	"./smartMobile.jpg": 8669,
	"./smartmirror.jpg": 358,
	"./wf.png": 1349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2764;